import { CoreMenu } from '@core/types';
import { Helper } from "../../@shared/Helper";
import { Features } from '@core/types/features.enum';

export class menuService {
  menuList: any[] = []
  constructor() {
    const user = Helper.getFromLocalStorage('payroll-user')
    // Looked up by id rather than by index: adding a top-level entry shifted the
    // positions and threw here, taking the whole sidebar down with it.
    const requests = menu.find(item => item.id === 'requests')
    requests.children[0].hidden = !JSON.parse(localStorage.getItem('companySettings'))?.enableEmployeeSelfServicesAccess
    requests.children[1].hidden = !JSON.parse(localStorage.getItem('companySettings'))?.enableEmployeeSelfServicesAccess || !JSON.parse(localStorage.getItem('defaultSetting'))?.enableRequestMissingPunch
    this.menuList = menu;
  }
}
let user = Helper.getFromLocalStorage('payroll-user')

export const menu: CoreMenu[] = [
  {
    id: 'home',
    title: 'Dashboard',
    // role: AllUserPolicy,
    type: 'item',
    icon: 'home',
    hidden: true,
    url: 'dashboard',
    moduleName: Features.Dashboard,
  },
  {
    id: 'employees',
    title: 'Employee',
    // translate: 'MENU.DASHBOARD.COLLAPSIBLE',
    type: 'collapsible',
    // role: AllUserPolicy, //? To hide collapsible based on user role
    icon: 'users',
    hidden: true,
    moduleName: Features.EMPLOYEE,
    children: [
      // {
      //   id: 'employees_search',
      //   title: 'Employees',
      //   type: 'item',
      //   hidden: true,
      //   // role: AllUserPolicy,
      //   icon: 'circle',
      //   url: 'employee/list',
      // },
      {
        id: 'employee-profile',
        title: 'Employee Profile',
        type: 'item',
        hidden: true,
        icon: 'circle',
        url: 'employee/employee-profile',
        moduleName: Features.EMPLOYEE,
      },
      {
        id: 'leaves',
        title: 'Leaves',
        type: 'item',
        hidden: true,
        // role: EmployeePolicy,
        icon: 'circle',
        url: 'leaves/list',
      },

      {
        id: 'employee-custom-field',
        title: 'Custom Fields',
        type: 'item',
        hidden: true,
        icon: 'circle',
        url: 'employee/custom-fields',
      },
      {
        id: 'employee-group',
        title: 'Groups',
        type: 'item',
        hidden: true,
        icon: 'circle',
        url: 'employee/groups',
      },
    ],
  },
  // {
  //   id: 'employee-profile',
  //   title: 'Employee Profile',
  //   type: 'item',
  //   hidden: true,
  //   icon: 'user',
  //   url: 'employee-profile',
  //   moduleName: Features.EMPLOYEE,
  // },
  {
    id: 'requests',
    title: 'Requests',
    icon: 'file-plus',
    type: 'collapsible',
    // role: AllUserPolicy,
    // hidden: !JSON.parse(localStorage.getItem('companySettings'))?.enableEmployeeSelfServicesAccess,
    hidden: true,
    url: null,
    moduleName: Features.REQUESTS,
    children: [
      {
        id: 'request-leave',
        title: 'Request Leave',
        icon: 'circle',
        // role: AllUserPolicy,
        type: 'item',
        hidden: true,
        url: 'requests/leaves',
        // hidden: !JSON.parse(localStorage.getItem('companySettings'))?.enableEmployeeSelfServicesAccess
      },
      {
        id: 'addtional-request',
        title: 'Add Additional Requests',
        icon: 'circle',
        // role: AllUserPolicy,
        hidden: true,
        type: 'item',
        url: 'requests/additional-requests',
        // hidden: !JSON.parse(localStorage.getItem('companySettings'))?.enableEmployeeSelfServicesAccess || !JSON.parse(localStorage.getItem('defaultSetting'))?.enableRequestMissingPunch
      },
      {
        id: 'view all',
        title: 'View All Requests',
        icon: 'circle',
        // role: AllUserPolicy,
        type: 'item',
        hidden: true,
        url: 'requests/view-all'
      },
      {
        id: 'approval-requests',
        title: 'My Approvals',
        icon: 'circle',
        // role: AllUserPolicy,
        type: 'item',
        hidden: true,
        url: 'requests/approval-requests'
      }

    ]
  },
  {
    id: 'time_management',
    title: 'Time Management',
    type: 'collapsible',
    // role: AllUserPolicy,
    icon: 'calendar',
    moduleName: Features.TIME_MANAGEMENT,
    hidden: true,
    children: [
      {
        id: 'time_management_manage',
        title: 'Time Sheet',
        type: 'item',
        // role: ReadOnlyPolicy,
        icon: 'circle',
        hidden: true,
        url: 'time-management/list',
      },
      {
        id: 'check-in-out',
        title: 'Check-In/Out',
        type: 'item',
        // role: AllUserPolicy,
        icon: 'circle',
        hidden: false,
        url: 'time-management/check-in-out',
      },
      {
        id: 'time_management_night_audit',
        title: 'Night Audit',
        type: 'item',
        // role: SupervisorLevel1Policy,
        icon: 'circle',
        hidden: true,
        url: 'time-management/night-audit',
      },
      {
        id: 'time_management_upload_sheet',
        title: 'Upload Timesheet',
        type: 'item',
        // role: SupervisorLevel1Policy,
        icon: 'circle',
        hidden: true,
        url: 'time-management/upload-sheet',
      },
      {
        id: 'time_management_attendence_sheet',
        title: 'Attendance Records',
        type: 'item',
        // role: SupervisorLevel3Policy,
        icon: 'circle',
        hidden: true,
        url: 'time-management/attendence-records',
      }, {
        id: 'pull-time-employee',
        title: 'Pull Times By Employee',
        type: 'item',
        // role: SupervisorLevel3Policy,
        icon: 'circle',
        hidden: true,
        url: 'time-management/pull-time-employee',
      },
    ],
  },
  {
    id: 'payroll-management',
    title: 'Payroll Management',
    type: 'collapsible',
    icon: 'credit-card',
    hidden: true,
    children: [
      {
        id: 'generate-payroll',
        title: 'Payroll Run',
        type: 'item',
        icon: 'circle',
        hidden: true,
        url: 'payroll/generate-payroll',
      },
      {
        id: 'disbursement',
        title: 'Disbursements',
        type: 'item',
        icon: 'circle',
        hidden: true,
        url: 'payroll/disbursement',
      },
      {
        id: 'upload_auto_transactions',
        title: 'Upload Auto Transactions',
        type: 'item',
        icon: 'circle',
        hidden: true,
        url: 'payroll/upload-auto-transactions',
      },
      {
        id: 'service-charge',
        title: 'Service Charge',
        type: 'item',
        icon: 'circle',
        hidden: true,
        url: 'payroll/service-charge',
      },
      {
        id: 'vacation-pay',
        title: 'Vacation Pay',
        type: 'item',
        icon: 'circle',
        hidden: true,
        url: 'payroll/vacation-pay',
      },
      {
        id: 'severance-pay',
        title: 'Severance Pay',
        type: 'item',
        icon: 'circle',
        hidden: true,
        url: 'payroll/severance-pay',
      },

      {
        id: 'pay-correction',
        title: 'Pay Correction',
        type: 'item',
        icon: 'circle',
        hidden: true,
        url: 'payroll/pay-correction',
      },
    ],
  },
  {
    id: 'roster',
    title: 'Roster',
    type: 'collapsible',
    // role: ReadOnlyPolicy,
    icon: 'list',
    moduleName: Features.ROSTER,
    hidden: true,
    children: [
      {
        id: 'add_roster',
        title: 'Add Roster',
        type: 'item',
        // role: SupervisorLevel1Policy,
        icon: 'circle',
        url: 'roster/create',
        hidden: true,
      },
      {
        id: 'list_roster',
        title: 'Roster',
        type: 'item',
        // role: ReadOnlyPolicy,
        icon: 'circle',
        url: 'roster/list',
        hidden: true,
      },
    ],
  },
  {
    id: 'users',
    title: 'Users',
    type: 'collapsible',
    // role: ManagerLevel1Policy, //? To hide collapsible based on user role
    icon: 'users',
    hidden: true,
    moduleName: Features.USERS,
    children: [
      {
        id: 'add_user',
        title: 'Add Normal User',
        type: 'item',
        // // role: AdminPloicy, //? To set multiple role: ['Admin', 'Client']
        icon: 'circle',
        hidden: true,
        url: 'user/create',
      },
      {
        id: 'list_user',
        title: 'Normal Users',
        type: 'item',
        // role: ManagerLevel1Policy,
        icon: 'circle',
        url: 'user/list',
        hidden: true,
      },
    ],
  },
  {
    id: 'setup',
    title: 'Setup',
    type: 'item',
    hidden: true,
    icon: 'file-text',
    moduleName: Features.REFERENCES,
    url: 'setup',
  },
  // {
  //   id: 'references',
  //   title: 'References',
  //   // translate: 'MENU.DASHBOARD.COLLAPSIBLE',
  //   type: 'collapsible',
  //   hidden: true,
  //   // role: ReadOnlyPolicy, //? To hide collapsible based on user role
  //   icon: 'file-text',
  //   moduleName: Features.REFERENCES,
  //   children: [
  //     {
  //       id: 'default_settings',
  //       title: 'Default Settings',
  //       type: 'item',
  //       // // role: ReadOnlyPolicy, //? To set multiple role: ['Admin', 'Client']
  //       icon: 'circle',
  //       hidden: true,
  //       moduleName: Features.REFERENCES_DEFAULT_SETTING,
  //       url: 'settings',
  //     },
  //     {
  //       id: 'geometric-locations',
  //       title: 'Geometric Locations',
  //       type: 'item',
  //       // role: SupervisorLevel3Policy,
  //       moduleName: Features.REFERENCES_ALL_OTHERS,
  //       icon: 'circle',
  //       hidden: true,
  //       url: 'geometric-locations/list',
  //     },

  //     // TO DO  will remove after finish payroll module
  //     // {
  //     //   id: 'payroll_accounts',
  //     //   title: 'Payroll Accounts',
  //     //   type: 'item',
  //     //   // // role: ReadOnlyPolicy, //? To set multiple role: ['Admin', 'Client']
  //     //   icon: 'circle',
  //     //   hidden: true,
  //     //   moduleName: Features.PAYROLL_ACCOUNTS,
  //     //   url: 'account/list',
  //     // },
  //     {
  //       id: 'departments',
  //       title: 'Department',
  //       moduleName: Features.REFERENCES_DEPARTMENT,
  //       type: 'item',
  //       // // role: ReadOnlyPolicy, //? To set multiple role: ['Admin', 'Client']
  //       icon: 'circle',
  //       hidden: true,
  //       url: 'department/list',
  //     },
  //     {
  //       id: 'holidays',
  //       title: 'Public Holidays',
  //       type: 'item',
  //       moduleName: Features.HOLIDAYS,
  //       // role: ReadOnlyPolicy,
  //       icon: 'circle',
  //       hidden: true,
  //       url: 'holidays',
  //     },
  //     {
  //       id: 'roster_times',
  //       title: 'Roster Times',
  //       type: 'item',
  //       moduleName: Features.ROSTER_TIMES,
  //       // role: ReadOnlyPolicy,
  //       icon: 'circle',
  //       hidden: true,
  //       url: 'roster-times',
  //     },
  //     {
  //       id: 'time-record-tags',
  //       title: 'Time Record Tags',
  //       type: 'item',
  //       moduleName: Features.TIME_RECORD_TAGS,
  //       // role: ReadOnlyPolicy,
  //       hidden: true,
  //       icon: 'circle',
  //       url: 'time-record-tags',
  //     },
  //     {
  //       id: 'time-record-tags-group',
  //       title: 'Tags Group',
  //       type: 'item',
  //       moduleName: Features.TAG_GROUPS,
  //       // role: ReadOnlyPolicy,
  //       hidden: true,
  //       icon: 'circle',
  //       url: 'time-record-tags-group',
  //     },
  //     {
  //       id: 'leave_reason',
  //       title: 'Leave Reasons',
  //       type: 'item',
  //       // role: ReadOnlyPolicy,
  //       hidden: true,
  //       icon: 'circle',
  //       moduleName: Features.LEAVE_REASONS,
  //       url: 'leave-reason',
  //     },
  //     {
  //       id: 'groups',
  //       title: 'Groups',
  //       hidden: true,
  //       type: 'item',
  //       // role: ReadOnlyPolicy, //? To hide collapsible based on user role
  //       icon: 'circle',
  //       moduleName: Features.GROUPS,
  //       url: 'groups',

  //     },
  //     {
  //       id: 'employee_class',
  //       title: 'Employee Group',
  //       type: 'item',
  //       // role: SupervisorLevel3Policy,
  //       icon: 'circle',
  //       moduleName: Features.EMPLOYEE_GROUP,
  //       url: 'employee-group/list',
  //       hidden: true,
  //     },

  //     // TO DO  will remove after finish payroll module
  //     // {
  //     //   id: 'paye-type',
  //     //   title: 'PAYE Type',
  //     //   type: 'item',
  //     //   moduleName: Features.PAYE_TYPE,
  //     //   // role: ReadOnlyPolicy, //? To hide collapsible based on user role
  //     //   icon: 'circle',
  //     //   hidden: true,
  //     //   url: 'paye-type',
  //     // },
  //     {
  //       id: 'banks',
  //       title: 'Banks',
  //       type: 'item',
  //       moduleName: Features.BANKS,
  //       // role: ReadOnlyPolicy, //? To hide collapsible based on user role
  //       icon: 'circle',
  //       hidden: true,
  //       url: 'banks',
  //     },
  //     {
  //       id: 'bank-branches',
  //       title: 'Bank Branches',
  //       type: 'item',
  //       moduleName: Features.BANK_BRANCHES,
  //       // role: ReadOnlyPolicy, //? To hide collapsible based on user role
  //       icon: 'circle',
  //       hidden: true,
  //       url: 'bank-branches',
  //     },
  //     {
  //       id: 'job-codes',
  //       title: 'Job Codes',
  //       type: 'item',
  //       moduleName: Features.JOB_CODES,
  //       hidden: true,
  //       // role: ReadOnlyPolicy, //? To hide collapsible based on user role
  //       icon: 'circle',
  //       url: 'job-codes',
  //     },
  //     {
  //       id: 'job-titles',
  //       title: 'Job Titles',
  //       type: 'item',
  //       moduleName: Features.JOB_TITLES,
  //       hidden: true,
  //       // role: ReadOnlyPolicy, //? To hide collapsible based on user role
  //       icon: 'circle',
  //       url: 'job-titles',
  //     },
  //     {
  //       id: 'business-rules',
  //       title: 'Business Rules',
  //       type: 'item',
  //       moduleName: Features.REFERENCES_BUSINESS_RULES,
  //       // role: ReadOnlyPolicy,
  //       hidden: true,
  //       icon: 'circle',
  //       url: 'business-rules/list',
  //     },
  //     {
  //       id: 'attachment-categories',
  //       title: 'Attach Categories',
  //       type: 'item',
  //       moduleName: Features.ATTACH_CATEGORIES,
  //       hidden: true,
  //       // role: ReadOnlyPolicy,
  //       icon: 'circle',
  //       url: 'attachment-categories',
  //     },
  //   ],
  // },
  {
    id: 'administration',
    title: 'Administration',
    type: 'collapsible',
    icon: 'settings',
    hidden: true,
    children: [
      {
        id: 'companies',
        title: 'Companies',
        type: 'item',
        // // role: SuperAdminPloicy, //? To set multiple role: ['Admin', 'Client']
        icon: 'circle',
        hidden: true,
        url: 'administration/companies',
      },
      {
        id: 'administration_users',
        title: 'Local Admins',
        type: 'item',
        // // role: SuperAdminPloicy, //? To set multiple role: ['Admin', 'Client']
        icon: 'circle',
        hidden: true,
        url: 'administration/users',
      },
      {
        id: 'roles',
        title: 'Roles',
        type: 'item',
        hidden: true,
        // // role: SuperAdminPloicy, //? To set multiple role: ['Admin', 'Client']
        icon: 'circle',
        url: 'administration/roles',
      },
      {
        id: 'upload-employees',
        title: 'Upload Employees',
        type: 'item',
        hidden: true,
        // // role: AdminPloicy, //? To set multiple role: ['Admin', 'Client']
        icon: 'circle',
        url: 'administration/upload-employees',
      },
      {
        id: 'file_types',
        title: 'File Types',
        type: 'item',
        hidden: true,
        // role: SuperAdminPloicy,
        icon: 'circle',
        url: 'administration/file-types',
      },
    ],
  },

  {
    id: 'reports',
    title: 'Reports',
    // role: ReadOnlyPolicy,
    type: 'item',
    icon: 'pie-chart',
    hidden: true,
    url: 'reports',
    moduleName: Features.REPORT_LINK,
  },


];
